import monitor, { EVENT_TYPES } from '../../../../../../service/bigquery';
import { getIdeaPageName } from '../getIdeaPageName';

/**
 * @typedef Input
 * @property {String} pageTagType
 * @property {String} pageTagId
 * @property {String} projectId
 * @property {String} variationId
 * @property {String} pageCtxId
 * @param {Input}
 * @returns {void}
 */
export const variationClicked = ({ pageTagType, pageTagId, projectId, variationId, pageCtxId }) => {
    const sendData = {
        page: {
            name: getIdeaPageName(pageTagType, pageTagId),
            referrer: {
                ctx_id: pageCtxId,
            },
        },
        makers_project: {
            id: projectId,
            variation: {
                id: variationId,
            },
        },
    };

    monitor.track(EVENT_TYPES.LISTINGS_VARIATION_CARD_CLICKED, sendData);
};
